
<div class="breadcrumb__container">

	<ng-container *ngFor="let bc of breadcrumbs; first as isFirst; last as isLast">
		<span *ngIf="isFirst" [routerLink]="[ bc.url ]" class="breadcrumb__item home" gtagEvent="ver-inicio" gtagCategory="breadcrumb"></span>

		<span [routerLink]="[ bc.url ]" *ngIf="bc.link" class="breadcrumb__item path__link" gtagEvent="ver-link" gtagCategory="breadcrumb">{{bc.label}}</span>
		<span *ngIf="!bc.link" class="breadcrumb__item">{{bc.label}}</span>
		
		<span *ngIf="!isLast" class="breadcrumb__item">/</span>
	</ng-container>

	<ng-container *ngIf="title">
		<span class="breadcrumb__item">/</span>
		<span class="breadcrumb__item path__title">{{title}}</span>
	</ng-container>

</div>